import { dateInputFormat } from '../utility/dateLocale';
export function DateColumnHeader({label,language,dateTime=false}:{label:string;language?:string;dateTime?:boolean}) {
 const english=dateInputFormat(language)==='MM/DD/YYYY';
 const format=english?'MM/DD/YYYY':'DD/MM/AAAA';
 return <span className="app-date-column-header"><span>{label}</span><span className="app-date-column-format">{format}{dateTime?(english?' · hh:mm AM/PM':' · HH:mm'):''}</span></span>;
}
